import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/eva/eva-core.min.css';
import './assets/css/eva/eva.min.css';
import './assets/css/social-web.css';
import './assets/css/skeleton.css';
import './config/AxiosConfig';
import App from './components/App';

ReactDOM.render(<App />, document.getElementById('profile-root'));
